import { GradeKey } from '@gyym/sdk'

export const gradeUpMessages = {
  [GradeKey.BEGINNER]: `おめでとうございます 🎉
あなたのGYYM PASSがBEGINNER PASSにランクアップしました。
お帰りなさい、また一緒に頑張りましょう📣 まずは、無理なく月1ペースからでも継続することが大切です🌟`,
  [GradeKey.LIGHT]: `おめでとうございます 🎉
あなたのGYYM PASSがLIGHT PASSにランクアップしました。
楽しく続けるコツはお友達と一緒に利用したりSNSに投稿することみたいです😄`,
  [GradeKey.STANDARD]: `おめでとうございます 🎉
あなたのGYYM PASSがSTANDARD PASSにランクアップしました。
フィットネスが習慣化されてきてますね✨ ライフスタイルとして定着するまでもう少し！`,
  [GradeKey.SILVER]: `おめでとうございます 🎉
あなたのGYYM PASSがSILVER PASSにランクアップしました。
すっかりフィットネスが習慣化されましたね🌟 マンネリ化を防ぐ工夫として月に1回はいつもと違う施設やプログラムを利用している人が多いそうですので試してみてください🙌`,
  [GradeKey.GOLD]: `おめでとうございます 🎉
あなたのGYYM PASSがGOLD PASSにランクアップしました。
遂にここまで来ましたね🏅 GYYMではフィットネスを楽しむ皆様を応援する為に、まだまだお得なGYYM PASSをご用意しています🎫 更なるランクアップを目指してみてくださいね💪`,
  [GradeKey.PREMIUM]: `おめでとうございます 🎉
あなたのGYYM PASSがPREMIUM PASSにランクアップしました。
所有者が限定されるプレミアムシリーズに突入しましたね🎫 ポイントバック率もさらにアップしています。引き続きお得にGYYMをお楽しみください👍`,
  [GradeKey.VIP]: `おめでとうございます 🎉
あなたのGYYM PASSがVIP PASSにランクアップしました。
フィットネス × ○○○という遊び心を取り入れた楽しみ方もVIPな貴方には似合うかもしれません🍽 週末の楽しみがグッと増えますよ🍰`,
  [GradeKey.GYYM_MASTER]: `おめでとうございます 🎉
あなたのGYYM PASSがGYYM MASTERにランクアップしました。
GYYM PASSの最高ランクまで到達しました🚀 いつもGYYMをご活用頂いてありがとうございます。最大の特典をご用意していますので、引き続きGYYMでのフィットネスをお楽しみください🌟`,
}
